/**
 * What a customer may do right now (#485).
 *
 * "Shopping enabled" used to answer two different questions at once: may this
 * customer order at all, and may they have food immediately. Outside opening
 * hours both were false, so the cart button disappeared and checkout refused
 * to load — exactly when someone wants to book tomorrow's lunch.
 *
 * @param {Object} params
 * @param {boolean} params.rawShoppingEnabled - the admin switch, before hours
 * @param {boolean|null} params.isClosed - null while the hours are unknown
 * @param {boolean} params.scheduledOrdersEnabled - the admin scheduling toggle
 * @param {boolean} params.forceClosed - an *indefinite* admin Force Close is
 *   in effect. A close with a duration is passed as an ordinary closure:
 *   pickups after it ends can still be scheduled
 * @returns {{asapAvailable: boolean, orderingEnabled: boolean}}
 */
export const resolveOrderingAvailability = ({
  rawShoppingEnabled = false,
  isClosed = false,
  scheduledOrdersEnabled = true,
  forceClosed = false,
} = {}) => {
  // An indefinite force close stops scheduled orders too (#668), so nothing
  // on the site may offer a way to order while it is in effect.
  if (forceClosed) return { asapAvailable: false, orderingEnabled: false };

  // A slow or failed hours read must not read as a closure: the server guard
  // refuses an ASAP order placed while closed either way (pickupWindow.js).
  const closed = isClosed === true;

  return {
    asapAvailable: Boolean(rawShoppingEnabled) && !closed,
    orderingEnabled:
      Boolean(rawShoppingEnabled) &&
      (!closed || Boolean(scheduledOrdersEnabled)),
  };
};

export default resolveOrderingAvailability;
